const type = 'RESET_SPENDINGLIMIT_CHANNELS';

const resetSpendingLimitChannels = () => ({
  type,
});

export { type };
export default resetSpendingLimitChannels;
